var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.constructor", "core-js/modules/es6.regexp.replace", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/core-js/promise"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.constructor"), require("core-js/modules/es6.regexp.replace"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/core-js/promise"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Regexp, global.keys, global.promise);
    global.utils = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Regexp2, _keys, _promise) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.truncateString = _exports.useDefault = _exports.formatTranslation = _exports.loadScript = _exports.isEurope = _exports.locales = _exports.loadSvgSprite = void 0;
  _keys = _interopRequireDefault(_keys);
  _promise = _interopRequireDefault(_promise);

  var _this = void 0;

  /* eslint-env browser */

  /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
  var loadSvgSprite = function loadSvgSprite() {
    return new _promise.default(function (resolve) {
      if (!global.document) {
        return resolve(new Error('Unable to load svg sprite'));
      }

      if (global.document.querySelectorAll('#asg-svg-sprite').length === 1) {
        return resolve(true);
      }

      var baseUrl = "https://static-cdn.arte.tv/static/styleguide/4.0.4";
      var request = new XMLHttpRequest();
      request.open('GET', "".concat(baseUrl, "/icomoon/symbol-defs.svg"), true);

      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          var div = global.document.createElement('div');
          div.setAttribute('id', 'asg-svg-sprite');
          div.setAttribute('aria-hidden', 'true');
          div.setAttribute('tabindex', '-1');
          div.innerHTML = request.responseText;
          global.document.body.insertBefore(div, global.document.body.childNodes[0]);
          var svgSprite = document.getElementById('asg-svg-sprite').querySelector('svg');

          if (svgSprite) {
            svgSprite.setAttribute('focusable', 'false');
            svgSprite.setAttribute('tabIndex', '-1');
          }

          return resolve(true);
        }

        return resolve(new Error('Unable to load svg sprite'));
      };

      request.onerror = function () {
        resolve(new Error('Unable to load svg sprite'));
      };

      return request.send();
    });
  };

  _exports.loadSvgSprite = loadSvgSprite;
  var locales = ['fr', 'de', 'en', 'es', 'pl', 'it'];
  _exports.locales = locales;

  var isEurope = function isEurope(locale) {
    return ['fr', 'de'].indexOf(locale) === -1;
  };

  _exports.isEurope = isEurope;

  var loadScript = function loadScript(url) {
    return new _promise.default(function (resolve, reject) {
      var script = global.document.createElement('script');
      script.type = 'text/javascript';
      var to = setTimeout(function () {
        var errorMessage = "The script ".concat(url, " timed out."); // eslint-disable-next-line no-console

        console.log(errorMessage);
        reject(new Error(errorMessage));
      }, 15000);

      script.onerror = function () {
        var errorMessage = "The script ".concat(url, " failed.");
        clearTimeout(to); // eslint-disable-next-line no-console

        console.log(errorMessage);
        reject(new Error(errorMessage));
      };

      script.onload = function () {
        clearTimeout(to);
        resolve(_this);
      };

      global.document.getElementsByTagName('head')[0].appendChild(script);
      script.src = url;
    });
  };
  /**
   * Format translation using flags (%{NAME})
   * @param String translation The string to format
   * @param Object substitutions Object with matching keys with values
   */


  _exports.loadScript = loadScript;

  var formatTranslation = function formatTranslation(translation, substitutions) {
    if (!translation) {
      return '';
    }

    var string = translation;
    (0, _keys.default)(substitutions || {}).forEach(function (k) {
      string = string.replace(new RegExp("%{".concat(k, "}"), 'g'), substitutions[k]);
    }); // empty unreplaced flags

    string = string.replace(new RegExp('%{[a-zA-Z-]*}', 'g'), '');
    return string;
  };
  /**
   * Returns the source if is not null or empty, otherwise return the default value provided
   * @param {Object} source Object to use if not empty or null
   * @param {Object} defaultValue Object to use if source object is empty or null
   */


  _exports.formatTranslation = formatTranslation;

  var useDefault = function useDefault(source) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!source || (0, _keys.default)(source).length === 0) {
      return defaultValue;
    }

    return source;
  };
  /**
   * truncate string at offset and adding "..." at the end
   * @example truncate(5, "Hello, my name is") // => "Hello..."
   * @param {integer} offset
   * @param {string} str
   */


  _exports.useDefault = useDefault;

  var truncateString = function truncateString(offset, str) {
    if (!str) return '';

    if (str.length <= offset) {
      return str;
    }

    return "".concat(str.slice(0, offset), "...");
  };

  _exports.truncateString = truncateString;
});